module.exports = __webpack_public_path__ + "img/marissa_and_jasper.ae91026c.jpg";